import { render } from "./delete_conference.vue?vue&type=template&id=832d01a2&scoped=true"
import script from "./delete_conference.vue?vue&type=script&lang=js"
export * from "./delete_conference.vue?vue&type=script&lang=js"

import "../../../assets/css/modal.css?vue&type=style&index=0&id=832d01a2&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-832d01a2"]])

export default __exports__